import { render, staticRenderFns } from "./blog-list.vue?vue&type=template&id=0e44bd24"
import script from "./blog-list.vue?vue&type=script&lang=ts"
export * from "./blog-list.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports